import "./RemoteTeamSecurityTips.module.css";
import Header from "@/reusable_sections/Header";
import Remotesecurityhero from "./sections/Remotesecurityhero";
import Optimization from "./sections/Optimization";
import Vpntechnicalsetup from "./sections/Vpntechnicalsetup";
import Cybersecurity from "./sections/Cybersecurity";
import RelatedArticlesGrid from "./sections/RelatedArticlesGrid";
import Footer from "@/reusable_sections/Footer";
export default function RemoteTeamSecurityTipsPage() {
  return <div>
      <Header />
      <Remotesecurityhero />
      <Optimization />
      <Vpntechnicalsetup />
      <Cybersecurity />
      <RelatedArticlesGrid />
      <Footer />
    </div>;
}